import styled, { css } from 'styled-components'

import { helpers } from 'styles'

import { Link as DefaultLink } from '../../Link'

export const Link = styled(DefaultLink)`
	display: grid;
	grid-template-columns: 1fr;
	column-gap: 4px;
	align-items: center;
	padding: 8px 16px;
	color: ${helpers.color.textMuted};

	${({ isActive = false }) =>
		isActive &&
		css`
		color: ${helpers.color.link};
	`}

	&:hover {
		background-color: ${helpers.color.linkBackgroundHover};
		color: ${({ isActive, theme }) => (isActive ? theme.color.link : theme.color.primary)};
	}
`
